module.exports = __webpack_public_path__ + "static/media/girl_my.e9a8f04e.png";